import { Component } from '@angular/core';

import { pedidoAbertoERP } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-aberto-erp',
    templateUrl: './pedido-status-badge-aberto-erp.component.html',
    styleUrls: ['./pedido-status-badge-aberto-erp.component.less']
})
export class PedidoStatusBadgeAbertoERPComponent {
    status = pedidoAbertoERP;
}
